import React, { useState } from "react";
import { useLang } from "@/i18n";
import { Section } from "./fields";
import { Clock } from "@phosphor-icons/react";

// value = ISO datetime string (selected visit time). Default handled by parent (Now).
export function VisitTimePicker({ value, onChange, testid = "visit-time" }) {
  const { lang, t } = useLang();
  const [mode, setMode] = useState("now");
  const [showPicker, setShowPicker] = useState(false);

  const pick = (m) => {
    setMode(m);
    if (m === "custom") { setShowPicker(true); return; }
    setShowPicker(false);
    const mins = { now: 0, "15": 15, "30": 30, "60": 60 }[m];
    onChange(new Date(Date.now() - mins * 60000).toISOString());
  };
  const onCustom = (e) => {
    if (!e.target.value) return;
    const [h, mn] = e.target.value.split(":").map(Number);
    const d = new Date();
    d.setHours(h, mn, 0, 0);
    onChange(d.toISOString());
  };
  const label = value
    ? new Date(value).toLocaleTimeString(lang === "hi" ? "hi-IN" : "en-IN", { hour: "2-digit", minute: "2-digit" })
    : "--";
  const opts = [["now", "vt_now"], ["15", "vt_15"], ["30", "vt_30"], ["60", "vt_1h"], ["custom", "vt_select"]];

  return (
    <Section title={t("visit_time")} testid="section-visit-time">
      <div className="flex flex-wrap gap-2" data-testid={testid}>
        {opts.map(([m, k]) => (
          <button
            key={m}
            type="button"
            data-testid={`${testid}-${m}`}
            onClick={() => pick(m)}
            className={`px-4 min-h-[44px] rounded-lg border text-sm font-medium transition-colors active:scale-95 ${
              mode === m ? "bg-slate-800 text-white border-slate-800" : "bg-white text-slate-700 border-slate-200"
            }`}
          >
            {t(k)}
          </button>
        ))}
      </div>
      {showPicker && (
        <input
          type="time"
          data-testid={`${testid}-input`}
          onChange={onCustom}
          className="mt-3 w-full min-h-[48px] rounded-lg border border-slate-200 px-3 text-lg"
        />
      )}
      <div className="mt-3 flex items-center gap-2 rounded-lg bg-emerald-50 px-3 py-2 text-emerald-800">
        <Clock size={18} weight="fill" />
        <span className="text-sm font-semibold">
          {t("selected_visit_time")}: <span data-testid={`${testid}-label`}>{label}</span>
        </span>
      </div>
    </Section>
  );
}
